module.exports = __webpack_public_path__ + "static/media/SS.81db5256.svg";